import {Controller, useForm} from 'react-hook-form'
import {Input} from '../inputs'
import clsx from 'clsx'
import {useContext, useEffect, useMemo} from 'react'
import moment from 'moment'
import {FORMATO_FECHAS} from '../../constantes/formatoFechas'
import {BotonSimple} from '../Botones'
import {ContextoAplicacion} from '../../contexto'
import {regexCorreoElectronico} from '../../constantes'

const defaultValues = {
  fechaInicial: null,
  fechaFinal: null,
  correo: null,
}

const GenerarReporteConEnvioCorreo = ({
  titulo = 'Generar reporte',
  funcionEjecutar = () => {},
}) => {
  const contextoAplicacion = useContext(ContextoAplicacion)
  const metodos = useForm({mode: 'onChange', defaultValues})

  const inicio = metodos.watch('fechaInicial')
  const fin = metodos.watch('fechaFinal')

  const fechaMaxima = useMemo(() => {
    return moment(inicio).isValid()
      ? moment(inicio)
          .add(6, 'months')
          .format(FORMATO_FECHAS.YYYY_MM_DD_GUIONES)
      : ''
  }, [inicio])

  const rangoFechasValido = useMemo(() => {
    const fechaInicial = moment(inicio, 'YYYY-MM-DD')
    const fechaFinal = moment(fin, 'YYYY-MM-DD')

    const diferenciaMeses = fechaFinal.diff(fechaInicial, 'months')

    return Boolean(diferenciaMeses <= 6)
  }, [inicio, fin])

  useEffect(() => {
    metodos.trigger()
  }, [])

  return (
    <div className="grid grid-cols-1 w-full gap-4">
      <div>
        <h1 className="text-cendiatra text-lg text-center uppercase font-bold">
          {titulo}
        </h1>
      </div>
      <div>
        <h3 className="text-cendiatra text-md text-center uppercase font-bold">
          Selecciona el rango de fechas a generar
        </h3>
        <br />
        <h6 className="text-cendiatra text-sm">
          Al confirmar se generará un archivo Excel con los enlaces a cada
          documento
          <br />
          El rango de fechas máximo para seleccionar es de 6 (Seis) meses.
        </h6>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Controller
            name="fechaInicial"
            rules={{required: true}}
            control={metodos.control}
            render={({field, fieldState}) => {
              return (
                <Input
                  estilosContenedor={'w-full items-start'}
                  onChange={(e) => {
                    field.onChange(e)
                    metodos.setValue('fechaFinal', null)
                  }}
                  estilosInput={clsx(
                    'appearance-none rounded relative block w-full p-1.5 text-cendiatra-gris-3 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm',
                    {
                      'border border-cendiatra-rojo-1 focus:border-cendiatra-rojo-1':
                        !!fieldState.error || !rangoFechasValido,
                      'border border-cendiatra focus:border-cendiatra':
                        !fieldState.error && rangoFechasValido,
                    }
                  )}
                  tipo={'date'}
                  titulo={'Fecha inicial*'}
                  valor={field.value}
                  fechaMaxima={metodos.watch('fechaFinal')}
                  posicionLabel="text-left"
                />
              )
            }}
          />
        </div>
        <div>
          <Controller
            name="fechaFinal"
            rules={{required: true}}
            control={metodos.control}
            render={({field, fieldState}) => {
              return (
                <Input
                  estilosContenedor={'w-full items-start'}
                  onChange={(e) => field.onChange(e)}
                  estilosInput={clsx(
                    'appearance-none rounded relative block w-full p-1.5 text-cendiatra-gris-3 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm',
                    {
                      'border border-cendiatra-rojo-1 focus:border-cendiatra-rojo-1':
                        !!fieldState.error || !rangoFechasValido,
                      'border border-cendiatra focus:border-cendiatra':
                        !fieldState.error && rangoFechasValido,
                    }
                  )}
                  tipo={'date'}
                  titulo={'Fecha final*'}
                  valor={field.value}
                  fechaMinima={inicio}
                  fechaMaxima={fechaMaxima}
                  posicionLabel="text-left"
                  deshabilitado={!inicio}
                />
              )
            }}
          />
        </div>
        <div className="col-span-full">
          <h6 className="text-cendiatra text-sm w-full">
            El documento se enviará al correo electrónico ingresado aquí.
          </h6>
          <Controller
            name="correo"
            rules={{required: true, pattern: regexCorreoElectronico}}
            control={metodos.control}
            render={({field, fieldState}) => {
              return (
                <Input
                  estilosContenedor={'w-full items-start'}
                  onChange={(e) => field.onChange(e)}
                  estilosInput={clsx(
                    'appearance-none rounded relative block w-full p-1.5 text-cendiatra-gris-3 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm',
                    {
                      'border border-cendiatra-rojo-1 focus:border-cendiatra-rojo-1':
                        !!fieldState.error,
                      'border border-cendiatra focus:border-cendiatra':
                        !fieldState.error,
                    }
                  )}
                  titulo={'Correo'}
                  valor={field.value}
                  posicionLabel="text-left"
                  placeholder={'Descripción'}
                />
              )
            }}
          />
        </div>
      </div>
      <div className="flex justify-center gap-4">
        <BotonSimple
          texto={'Regresar'}
          estilosBoton={
            'h-40px w-40 p-1.5 rounded-lg bg-cover bg-no-repeat bg-center text-white font-bold text-14px bg-cendiatra'
          }
          funcion={() =>
            contextoAplicacion.setModal({
              abierto: false,
              titulo: '',
              contenido: '',
              botones: [],
            })
          }
        />
        <BotonSimple
          texto={'Enviar'}
          estilosBoton={clsx(
            'h-40px w-40 p-1.5 rounded-lg bg-cover bg-no-repeat bg-center text-white font-bold text-14px',
            {
              'bg-cendiatra': metodos.formState.isValid && rangoFechasValido,
              'bg-cendiatra-gris-2 pointer-events-none':
                !metodos.formState.isValid || !rangoFechasValido,
            }
          )}
          funcion={() => {
            funcionEjecutar(metodos.getValues())
            contextoAplicacion.setModal({
              abierto: false,
              titulo: '',
              contenido: '',
              botones: [],
            })
          }}
        />
      </div>
    </div>
  )
}

export default GenerarReporteConEnvioCorreo
